import React, { type ReactNode } from 'react';
import { defaultRenderers } from 'components/Markdown';
import { Typography, TypographyVariant } from 'components/Typography';
import { type TypographyVariantType } from 'components/Typography/types';

export const getTypographyForMarkdown = (
  TypographyVariantName: TypographyVariantType = TypographyVariant.BodyMd,
  Tag: 'p' | 'span' = 'p'
) => ({
  ...defaultRenderers,
  paragraph: ({ children }: { children: ReactNode }) => (
    <Typography variant={TypographyVariant[TypographyVariantName]}>
      <Tag>{children}</Tag>
    </Typography>
  )
});
